import React from 'react';
import {
  NavLink
} from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import { useTranslation } from 'react-i18next';

// icon
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { DataIcon } from '../../assets/svg/Icon';
import { StyledLinkButton } from '../../components/button/Button';

// style
import { styles } from './style';

const initPath = `/${process.env.REACT_APP_PATH}`;
const useStyles = makeStyles(styles);

export default function Footer() {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <Box display="flex" className={classes.boxViewFooter}>
        <Box mx={4} p={1} display="flex" justifyContent="flex-end">
          <NavLink to={initPath}>
            <Box display="flex">
              <Box><DataIcon color="primary" /></Box>
              <Box>
                <Typography id="thaiwater-text" noWrap variant="h6" style={{ fontSize: 14 }}>
                  {t('คลังข้อมูลน้ำแห่งชาติ')}
                </Typography>
              </Box>
            </Box>
          </NavLink>
        </Box>
        <Box>
          <NavLink to={`${initPath}rainfall`}>
            <StyledLinkButton id="detail-button">
              {/* คอมเม้นต์ให้พี่โพ build ผ่าน สาธุ อีกรอบๆๆๆๆๆ */}
              <Typography noWrap variant="h6" style={{ fontSize: 15 }}>
                {t('รายละเอียด')}
              </Typography>
              <NavigateNextIcon />
            </StyledLinkButton>
          </NavLink>
        </Box>
      </Box>
    </>
  );
}
